import geoJSON from 'utils/geoJSON/geoJSON'
import ObjectTools from 'utils/objects/objectTools'

const generalConfig = {
  chart: {
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    },
    marginBottom: 30,
    events: {
      load: function() {
        const series = this.series[0].data
        let id
        for (let i = 0; i < series.length; i++) {
          const item = series[i]
          if (item.id) {
            id = item.id
          }
        }
        const x = this.get(id).plotX
        const y = this.get(id).plotY
        this.mapZoom(0.3, this.xAxis[0].toValue(x, false), this.yAxis[0].toValue(y, true), x, y)
      }
    }
  },
  title: {
    text: '',
    floating: true,
    align: 'right',
    x: 1,
    y: 12,
    useHTML: true,
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#717171',
      backgroundColor: '#FFF',
      padding: '5px 10px 5px 10px',
      borderRadius: '0px 0px 0px 10px'
    }
  },
  credits: {
    enabled: false,
    text: '',
    href: 'https://www.orkestra.deusto.es',
    position: {
      y: -10
    },
    style: {
      fontSize: '12px'
    }
  },
  exporting: {
    sourceWidth: 800,
    sourceHeight: 550,
    buttons: {
      contextButton: {
        enabled: false
      }
    },
    allowHTML: true
  },
  tooltip: {
    enabled: false,
    valueSuffix: '',
    formatter: function() {
      return `<span style="font-weight: bold; font-size: 10px">${this.point.options.countryName}</span><br/> <span>${this.point.options.name} (${
        this.point.options.code
      })</span>`
    },
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    }
  },
  mapNavigation: {
    enabled: true,
    enableButtons: false,
    buttonOptions: {
      verticalAlign: 'top',
      alignTo: 'spacingBox'
    }
  },
  colorAxis: {
    tickPixelInterval: 50,
    startOnTick: false,
    endOnTick: false,
    labels: {
      align: 'right',
      x: 30
    },
    reversed: false
  },
  legend: {
    enabled: false,
    borderWidth: 0,
    padding: 0,
    itemDistance: 2,
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'bottom',
    floating: false
  },

  series: []
}

let selectedRegionConfig = ObjectTools.copyObject(generalConfig)
const domProps = {
  style: {},
  id: 'cosaChart'
}
const chartMapConfig = {
  geoJSON,
  generalConfig,
  selectedRegionConfig,
  domProps
}

export default chartMapConfig



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/LayerHeaderMap/LayerHeaderMapConfig.js